import {styled} from '@mui/material/styles'
import {Paper, ToggleButton} from '@mui/material'
import ToggleButtonGroup, {toggleButtonGroupClasses} from '@mui/material/ToggleButtonGroup'
export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.4),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0
    }
  },
  [`& .${toggleButtonGroupClasses.selected}`]: {
    backgroundColor: theme.palette.hpPrimary // Apply hpPrimary color as background
  },

  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
    marginLeft: -1,
    borderLeft: '1px solid transparent'
  }
}))
export const StyledToggleButton = styled(ToggleButton, {shouldForwardProp: (prop) => prop !== 'isText'})(
  ({theme, isText}) => ({
    height: isText ? '18px' : '28px',
    width: isText ? 'fit-content' : '32px',
    color: isText ? theme.palette.hpBlack : theme.palette.hpBaseDarker,
    '&.Mui-selected': {
      backgroundColor: isText ? theme.palette.hpPrimary : theme.palette.hpWhite,
      color: isText ? theme.palette.hpWhite : theme.palette.hpPrimaryDark,
      '&:hover': {
        backgroundColor: isText ? theme.palette.hpPrimaryDark : theme.palette.hpWhite
      }
    }
  })
)

export const StyledPaper = styled(Paper, {shouldForwardProp: (prop) => prop !== 'isMapContainer'})(
  ({isMapContainer, theme}) => ({
    display: 'flex',
    width: 'fit-content',
    backgroundColor: theme.palette.hpBaseLighter,
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
    marginTop: isMapContainer ? '-24px' : ''
  })
)
